// extracted by mini-css-extract-plugin
export default {"wrapper":"Game_wrapper__L7HJC","iframe":"Game_iframe__MHJtV"};